import { createContext } from "react";


class GuestsStore {
  columnVisibility = {}
  columnFilters = []
  globalFilter = undefined
  searchField = 'fullName'
  pagination = { pageIndex: 0, pageSize: 10 }
  // State preservation fields
  tableData = []
  isLoading = true
  isRefetching = false
  open = false
  scrollTop = 0
  needsRefresh = false
}


export const guestsStore = new GuestsStore()
export const GuestsStoreContext = createContext(guestsStore)
